








import Vue from 'vue'
import Postmate from 'postmate'
import config from '@/config'
import firebase from 'firebase/compat/app'
import { User } from '../../../models'
import { Utils } from '../../../util/utils'
import { useEmitter } from '../../composition/useEmitter'
import { contentAiPermission } from '../../../util/email_builder_helper'
import { Location } from '@/models'

export default Vue.extend({
  props: {
    location: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    routePath: {
      type: String,
      required: false,
    },
    customValues:{
      type:Array,
      required:false
    }
  },
  data() {
    return {
      handshake: {},
      emitter: undefined,
    }
  },
  mounted() {
    this.emitter = useEmitter()
    this.loadMicroApp()
    this.emitter.on('content-ai-generated-content', (id: string) => {
      //@ts-expect-error
      this.handshake.then((child: any) => {
        child.call('content-ai-generated-content', id)
      })
    })
    this.emitter.on('content-ai-generated-image', (id: string) => {
      //@ts-expect-error
      this.handshake.then((child: any) => {
        child.call('content-ai-generated-image', id)
      })
    })

    this.emitter.on('quick-action-generated-session', (payload: any) => {
      //@ts-expect-error
      this.handshake.then((child: any) => {
        child.call('quick-action-generated-session', payload)
      })
    })



    Utils.toggleCustomJsVisibility('none')
  },
  beforeDestroy() {
    //@ts-expect-error postmate handler
    this.handshake.then((child: any) => {
      child.destroy()
    })
    Utils.toggleCustomJsVisibility('inline')
  },
  computed: {
    userValue() {
      return new User(this.user)
    },
    isNewBuilder(){
      // return this.$store.getters['featureFlags/getForLocation']('emailBuilder.newFeatures')
      return false
    }
  },
  methods: {
    async getToken() {
      return await firebase.auth().currentUser.getIdToken()
    },
    async loadMicroApp() {
      const routerName = this.$route.name || this.routePath
      if (!routerName) return
      const routePath = this.routePath || this.$route.path
      let query = ''
      try {
        query = Object.entries(this.$route.query)
          .flatMap(([key, value]) => [value].flat().map(v => [key, v]))
          .map(it => it.join('='))
          .join('&')
      } catch (err) {
        console.warn(err)
      }
      let storageLocale = localStorage.getItem("locale")
      const url = `${this.isNewBuilder ? config.newEmailPreviewBetaUrl : config.emailPreviewAppUrl}${routePath}?${query}`
      this.handshake = new Postmate({
        container: this.$refs.emailBuilder as HTMLElement,
        url,
        name: 'email-preview',
        model: {
          userId: this.user.id,
          email: this.user.email,
          apiKey: this.location.api_key,
          userName: `${this.user.first_name} ${this.user.last_name}`,
          timeZone: this.location.timezone,
          tokenId: await this.getToken(),
          userPermissions: {
            ...this.user.permissions,
            enableContentAI: await contentAiPermission(
              this.location.id,
              this.location.company_id,
              this.user.permissions
            ),
          },
          enableAssignToData: this.user && this.user.role === 'user' && this.user.permissions.assigned_data_only ,
          companyId: this.location.company_id,
          isNewBuilder: this.isNewBuilder,
          customValues: this.customValues,
          locale: storageLocale || 'en'
        },
      })
      //@ts-expect-error postmate handler
      this.handshake.then((child: any) => {
        child.on('spm-ts', (data: any) => {
          this.$router.push(data.router)
        })
        child.on('refresh-token', async () => {
          child.call('updated-token', await this.getToken())
        })
        child.on('exit-email-builder', (data: any) => {
          let response = false
          if (data.unsavedChanges) {
            response = !window.confirm(data.message)
          }
          if (!response) {
            if (data.name) {
              const routeInfo = { name: data.name } as any
              if (data.query) {
                routeInfo.query = data.query
              }
              this.$router.push(routeInfo)
            } else this.$router.push(data.router)
          }
        })
        child.on('close-builder-modal', () => {
          this.$emit('model:close')
        })

        child.on(
          'content-ai-variations-generate',
          ({ source = 'email_builder', type }) => {
            this.emitter.emit('content-ai-variations-generate', {
              source,
              type,
            })
          }
        )
      
        child.on('content-ai-variations-show', (id: string) => {
          this.emitter.emit('content-ai-variations-show', {
            source: 'email_builder',
            id,
          })
        })

        child.on(
          'image-ai-generate',
          () => {
            this.emitter.emit('image-ai-generate', {
              source:'email_builder',
            })
          }
        )

        child.on('image-ai-variations-show', (id: string) => {
          this.emitter.emit('image-ai-variations-show', {
            source: 'email_builder',
            id,
          })
        })

        child.on('content-ai-quick-action', (payload:any) => {
          this.emitter.emit('content-ai-quick-action', {
            selectedText:payload.text,
            contextualType:payload.type,
            type:'body',
            source: 'email_builder',
          })
        })
      })
    },
  },
})
